import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostListener, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment as env } from '../../../environments/environment';
import { MediaService } from '../../services/media.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(250, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate(250, style({ opacity: 0 }))
      ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {

  logoSrc: string;
  private subscriptions = new Map<string, Subscription>();

  @Input() header: string;
  @Input() showCart = true;
  open: boolean;
  packetLengths: number[];
  showTableHelper: boolean;

  constructor(
    public menuService: MenuService,
    public mediaService: MediaService,
  ) { }

  ngOnInit() {
    this.packetLengths = env.packetLengths;
    this.logoSrc = env.logoSrc;
    this.subscriptions.set('menuServiceState',
      this.menuService.state.subscribe(open => {
        this.open = open;
      })
    );
    this.subscriptions.set('menuServiceShowTableHelper',
      this.menuService.showTableHelper$.subscribe(show => {
        this.showTableHelper = show;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onToggleMenu() {
    this.menuService.toggle();
  }

  @HostListener('window:scroll', ['$event'])
  onResize() {
    this.menuService.setScrollY(window.scrollY);
  }

}
